import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import * as logAction from '../../../actions/logAction';
import ListLinkBox from '../../../components/UI/ListLinkBox';
import { translate, msgAppHandler, getPathApp } from '../../../utils/util';
import * as actionsPhysicalConfirmation from '../../../actions/physicalConfirmationAction';
import AreaService from '../../../services/AreaService';
import { VISIONS, PERMISSIONS } from '../../../utils/constants';
import { getVision, checkPermission } from '../../../services/auth';

const PhysicalConfirmation = (props) => {

    useEffect(() => {
        //Remove Evento Antigo e add novamente
        document.removeEventListener('message', msgAppHandler);
        document.addEventListener('message', msgAppHandler);
        props.resetPhisicalConfirmation();
        props.getAreas(props.user.vision, {
            plantId: props.user.vision.split('-')[0]
        }, {});
        props.clearLogs();
        props.setFilter({})
        // eslint-disable-next-line
    }, []);

    const menu = () => {
        let menuItems = [];
        menuItems = [...menuItems, {
            route: 'receiptStorages',
            icon: 'assignment_turned_in',
            text: translate('menu:physical-confirmation')
        }];

        if (getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) {
            menuItems = [...menuItems, {
                route: 'multiInvoice',
                icon: 'assignment_turned_in',
                text: `Multi ${translate('menu:physical-confirmation')}`
            }];

            menuItems = [...menuItems, {
                route: 'reprocesssearch',
                icon: 'mdi mdi-monitor',
                text: translate('reprocess-monitor', 'physical-confirmation')
            }];
        }

        menuItems = [...menuItems, {
            route: 'partNumberQuantity',
            icon: 'mdi mdi-clipboard-check-outline',
            text: translate('physical-confirmation:part-number-quantity')
        }];

        menuItems = [...menuItems, {
            route: 'outside',
            icon: 'compare_arrows',
            text: translate('physical-confirmation:out-piece')
        }];

        menuItems = [...menuItems, {
            route: { pathname: '/receipt/V2/searchByPartNumber' },
            icon: 'mdi mdi-monitor',
            text: translate('physical-confirmation:search-partnumber')
        }];

        menuItems = [...menuItems, {
            route: { pathname: '/receipt/V2/receiptByLabel' },
            icon: 'mdi mdi-file-document-outline',
            text: translate('physical-confirmation:receipt-by-label')
        }];

        menuItems = [...menuItems, {
            route: {
                pathname: '/receipt/V2/monitor',
                state: { showBackButton: true, inDock: true }
            },
            icon: 'mdi mdi-monitor', text: translate('physical-confirmation:monitor')
        }];

        menuItems = [...menuItems, {
            route: 'container', icon: 'compare_arrows', text: translate('physical-confirmation:receipt-by-container')
        }];

        menuItems = [...menuItems, {
            route: 'generalReport',
            icon: 'mdi mdi-clipboard-list-outline',
            text: translate('physical-confirmation:reports-and-rmd')
        }];

        menuItems = [...menuItems, {
            route: 'updateMvm',
            icon: 'replay',
            text: translate('physical-confirmation:mvm-update')
        }];

        if (getVision() !== VISIONS.Faasa && getVision() !== VISIONS.FaasaCKD) {
            menuItems = [...menuItems,
            {
                route: 'searchmvi',
                icon: 'mdi mdi-truck-delivery-outline',
                text: translate('physical-confirmation:search-mvi')
            }];
        }

        menuItems = [...menuItems,
        {
            route: 'transmissions',
            icon: 'mdi mdi-clipboard-list-outline',
            text: translate('physical-confirmation:transmissions')
        }];

        menuItems = [...menuItems, {
            route: 'logs',
            icon: 'chrome_reader_mode', text: 'Logs'
        }];

        menuItems = [...menuItems, {
            route: 'changeReport',
            icon: 'mdi mdi-clipboard-list-outline',
            text: translate('physical-confirmation:qme-mdr-changes')
        }];

        // menuItems = [...menuItems, {
        //     route: 'errormonitor',
        //     icon: 'mdi mdi-monitor-dashboard',
        //     text: translate('physical-confirmation:wrong-shed-monitor')
        // }];

        menuItems = [...menuItems, {
            route: 'receiptParameters',
            icon: 'chrome_reader_mode',
            text: translate('menu:settings')
        }];

        if (checkPermission(PERMISSIONS.PhysicalConfirmation.Config)) {
            menuItems = [...menuItems, {
                route: {
                    pathname: `${getPathApp(window)}/config/params/physicalConfirmation`,
                    state: { isUser: true }
                },
                icon: 'mdi mdi-cogs',
                text: translate('menu:parameterization')
            }];
        }

        if (checkPermission(PERMISSIONS.PhysicalConfirmation.Reopen)) {
            menuItems = [...menuItems, {
                route: 'reopen',
                icon: 'lock_open',
                text: translate('reopen', 'physical-confirmation')
            }];
        }

        menuItems = [...menuItems, {
            route: 'printlabel',
            icon: 'print',
            text: translate('label-reprint', 'physical-confirmation')
        }];


        menuItems = [...menuItems, {
            route: 'print/identification',
            icon: 'filter_frames',
            text: translate('identification-label', 'physical-confirmation')
        }];

        menuItems = [...menuItems, {
            route: 'mastercim',
            icon: 'mdi mdi-layers-triple-outline',
            text: 'Gerar Master CIM'
        }];

        menuItems = [...menuItems, {
            route: 'closeMvi',
            icon: 'mdi mdi-truck-delivery-outline',
            text: 'Fechar MVI'
        }];

        return menuItems;
    };

    return (
        <div>
            <div className="container-fluid h-65">
                <div className="row">
                    <div className="title">
                        <i className="mdi mdi-dolly" />
                        {translate('menu:physical-confirmation')}
                    </div>
                </div>
            </div>
            <div className="container" style={{ marginLeft: '5px', marginTop: '40px', }}>
                <ListLinkBox
                    options={menu()}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        resetPhisicalConfirmation: () => {
            dispatch(actionsPhysicalConfirmation.clearPhysicalConfirmation());
        },
        getAreas: (vision, filter, pagination) => {
            dispatch(AreaService.getAreas(vision, filter, pagination));
        },
        setFilter: (filter) => {
            dispatch(actionsPhysicalConfirmation.setFilter(filter));
        },
        clearLogs: () => {
            dispatch(logAction.setLogs());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PhysicalConfirmation));